/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SapS4HanaGetSalesQuotationFromRemoteQueryVariables = Types.Exact<{
  salesQuotationId: Types.Scalars['ID']['input'];
}>;


export type SapS4HanaGetSalesQuotationFromRemoteQuery = { sapS4HanaGetSalesQuotationFromRemote: { __typename: 'SapS4HanaGetSalesQuotationFromRemoteResult', salesQuotation: any } };


export const SapS4HanaGetSalesQuotationFromRemoteDocument = gql`
    query SapS4HanaGetSalesQuotationFromRemote($salesQuotationId: ID!) {
  sapS4HanaGetSalesQuotationFromRemote(salesQuotationId: $salesQuotationId) {
    salesQuotation
  }
}
    `;

/**
 * __useSapS4HanaGetSalesQuotationFromRemoteQuery__
 *
 * To run a query within a React component, call `useSapS4HanaGetSalesQuotationFromRemoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSapS4HanaGetSalesQuotationFromRemoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSapS4HanaGetSalesQuotationFromRemoteQuery({
 *   variables: {
 *      salesQuotationId: // value for 'salesQuotationId'
 *   },
 * });
 */
export function useSapS4HanaGetSalesQuotationFromRemoteQuery(baseOptions: Apollo.QueryHookOptions<SapS4HanaGetSalesQuotationFromRemoteQuery, SapS4HanaGetSalesQuotationFromRemoteQueryVariables> & ({ variables: SapS4HanaGetSalesQuotationFromRemoteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SapS4HanaGetSalesQuotationFromRemoteQuery, SapS4HanaGetSalesQuotationFromRemoteQueryVariables>(SapS4HanaGetSalesQuotationFromRemoteDocument, options);
      }
export function useSapS4HanaGetSalesQuotationFromRemoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SapS4HanaGetSalesQuotationFromRemoteQuery, SapS4HanaGetSalesQuotationFromRemoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SapS4HanaGetSalesQuotationFromRemoteQuery, SapS4HanaGetSalesQuotationFromRemoteQueryVariables>(SapS4HanaGetSalesQuotationFromRemoteDocument, options);
        }
export function useSapS4HanaGetSalesQuotationFromRemoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SapS4HanaGetSalesQuotationFromRemoteQuery, SapS4HanaGetSalesQuotationFromRemoteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SapS4HanaGetSalesQuotationFromRemoteQuery, SapS4HanaGetSalesQuotationFromRemoteQueryVariables>(SapS4HanaGetSalesQuotationFromRemoteDocument, options);
        }
export type SapS4HanaGetSalesQuotationFromRemoteQueryHookResult = ReturnType<typeof useSapS4HanaGetSalesQuotationFromRemoteQuery>;
export type SapS4HanaGetSalesQuotationFromRemoteLazyQueryHookResult = ReturnType<typeof useSapS4HanaGetSalesQuotationFromRemoteLazyQuery>;
export type SapS4HanaGetSalesQuotationFromRemoteSuspenseQueryHookResult = ReturnType<typeof useSapS4HanaGetSalesQuotationFromRemoteSuspenseQuery>;
export type SapS4HanaGetSalesQuotationFromRemoteQueryResult = Apollo.QueryResult<SapS4HanaGetSalesQuotationFromRemoteQuery, SapS4HanaGetSalesQuotationFromRemoteQueryVariables>;